






































import {Component, Mixins, Prop} from 'vue-property-decorator';
import TranslatedRouter from '@/mixins/TranslatedRouter';

@Component({})
export default class LangSwitch extends Mixins(TranslatedRouter) {
	@Prop({required: false}) readonly styles: { marginTop: string };

	language(locale: string): any {
		return {
			default: process.env.ASSET_BASE + require(`@/images/languages/${locale}@2x.png`),
			retina: process.env.ASSET_BASE + require(`@/images/languages/${locale}@2x.png`)
		}
	}

	get customStyles(): { marginTop: string } {
		return this.styles;
	}

}
